export const useGetTenantAlias = (): string =>
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_TENANT_ALIAS as string
    : window.location.hostname.split('.')[0] as string;
